import React from 'react';
import NPPanel from '../../NPPanel';
import { Col, Row } from 'react-bootstrap';


import "react-table/react-table.css";
import 'bootstrap/dist/css/bootstrap.css';

import constants from '../../util/constants';
import axios from 'axios';
import { getFilteredData, filterMultiple } from '../../gridHelpers/gridHelpers';
import NPHelpButton from '../../NPHelpButton';
import NPReactTable from '../../NPReactTable';
import LoadingSpinner from '../../LoadingSpinner';


import './style.scss';


const { API_BASE_URL } = constants;

class PendingUser extends React.Component{
        constructor(props) {
          super(props);   
          this.state = { users: undefined, loaded:false };
          this.getUsers = this.getUsers.bind(this);
          this.handleSelectChange = this.handleSelectChange.bind(this);     
      }
      
      componentDidMount(){
        this.axiosCancelSource = axios.CancelToken.source();
        this.getUsers();
      }

      componentWillUnmount () {
        this.axiosCancelSource.cancel('Component unmounted.')
      }
      

      clearCurrentExpandforAll() {
        let d = getFilteredData(this.reactTable.getReactTable());
        this.currentExpand = '';
        d.forEach(dt => {
            dt.TAG = undefined;
        });
      }

      handleSelectChange(evt, item, row){
        if (item && row && row.original) {
          let selIndex=evt.currentTarget.selectedIndex;
          evt.currentTarget.selectedIndex=0;
          this.props.viewUserCommand(selIndex, row.original.Id);      
          }
        }

      getcolumns() {
          const helpNode = (
              <div>
                <h3>Buttons</h3>

                <h4>Reset</h4>
                <p>Resets filters, sorting, column widths and navigates to first page.</p>

                <h4>Excel</h4>
                <p>Exports the data to excel according to filters and sorting.</p>

                <h3>Filters</h3>

                <p>There are fields at the top of the table that can be used for filtering</p>

                <p>
                    If a text box for a column is empty, no filtering for that column will be done.<br />
                    If the data is left-aligned and the text box is not empty, the filter will remove rows that do not contain the text in the text box<br />
                    It is possible to use multiple filters for text based values by writing a comma, for example "Ordered, Being produced"<br /><br />
                    Examples follows for right-aligned (numbers):<br />
                    Empty text box, no filtering.<br />
                    <strong>&lt; 10</strong> view rows with data that is less than 10<br />
                    <strong>&gt; 10</strong> view rows with data that is more than 10<br />
                    <strong>20-30</strong> view rows with data that is between 20 and 30.
                </p>
              </div>
            );



        return ([

            {
                Header: "Pending Users",
                headerStyle: { background: '#dedede' },
                columns: [
                  {
                    Header: "",
                    maxWidth: 30,
                    Filter: ({ filter, onChange }) =>
                        <NPHelpButton content={helpNode} title="Help" />,
                        Cell: (row) =>
                        {
                          return <span>
                          <select  className='tst myopt handy' onChange={evt => { this.handleSelectChange(evt, evt.target.value, row, this);}}>
                            <option value="">...</option>
                            <option value="Edit">Modify this user</option>  
                          </select>
                        </span>
                        }
                    },
                    {
                      Header: "Email",
                      accessor: "Email",
                  },
                  {
                    Header: "Client Code Regional / Market Area Code",
                    accessor: "ClientCodeRegional",
                  },
                  {
                    Header: "User Type",
                    accessor: "Settings.UserType",
                  },
                   
                    
                ]
            },

        ]);
    }

    getUsers() {
      const header = {
          'Authorization': 'Bearer ' + this.props.apiToken,
          'Accept': 'application/octet-stream'
      };

      let self = this;
      self.setState({ isLoading: true });

      axios.get(API_BASE_URL + 'Admin/GetUsers', { headers: header, cancelToken: this.axiosCancelSource.token })
          .then(result => {
            const users = result.data.filter(item => {
              return item.Settings && item.Settings.HasAccess === false;
            }).sort((a,b) => a.Email.localeCompare(b.Email, undefined, {numeric: true}));
            
             var usermod = Object.keys(users).map(function(key) {
              users[key].Settings.IsLocked === false ? users[key].Settings.IsLocked = 'Open' : users[key].Settings.IsLocked = 'Locked' 
              if(users[key].ClientCodeRegional != null && users[key].ClientCodeRegional.length > 1){
                users[key].ClientCodeRegional = users[key].ClientCodeRegional.join(', ');
              }
          });
            self.setState({isLoading: false, loaded: true, users: users, expanded: {} });
          }).catch(response => { });
          
  }


    render(){

     // Concatinate ClientCodeRegional to be displayed in ReactTable. 
  
      if(this.state.users && this.state.users.ClientCodeRegional){
        let users = {...this.state.users}
        users.ClientCodeRegional = users.ClientCodeRegional.join();
        this.setState({ users });
      }
      let users = this.state.users;

      if (!users || this.state.isLoading) {
        return <LoadingSpinner isLoading={true} />
      }
        return( 
            <NPPanel>
                <Row id="pending-users">
                  <Col sm={12}>
                  <Row>
                    <Col sm={12} className="margin-top-10">
                    {this.state.loaded?
                        <NPReactTable
                            className="np-react-table"                        
                            data={users}
                            ref={(r) => { this.reactTable = r }}
                            columns={this.getcolumns()}
                            defaultFilterMethod={filterMultiple}
                            filterable
                            filterAll
                            defaultPageSize={10}
                            // Controlled props
                            sorted={this.state.sorted}
                            page={this.state.page}
                            pageSize={this.state.pageSize}
                            expanded={this.state.expanded}
                            resized={this.state.resized}
                            filtered={this.state.filtered}
                              // Callbacks
                              onSortedChange={sorted => this.setState({ sorted, expanded: {} })}
                              onPageChange={
                                  page => {
                                      this.clearCurrentExpandforAll();
                                      this.setState({ page, expanded: {} });
                                  }
                              }                            
                              onPageSizeChange={(pageSize, page) => {
                                  this.clearCurrentExpandforAll();
                                  this.setState({ page, pageSize, expanded: {} });
                              }
                              }
                              onResizedChange={resized => this.setState({ resized })}
                              onFilteredChange={filtered => {
                                  //this.clearCurrentExpandforAll();
                                  this.setState({ filtered, page: 0, expanded: {} })
                              }
                              }
                          />
                        :null
                        }
                    </Col> 
                  </Row>
                  </Col>
                </Row>
              </NPPanel>
        ); 
    }
}

export default PendingUser;